import { type ComponentProps, memo, type RefObject } from 'react';

import { SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH } from '~/utils/videoThumbnails';

export type VideoScrubbableThumbnailProps = Pick<ComponentProps<'div'>, 'style'> & {
  backgroundImageRef: RefObject<HTMLDivElement>;
  indicatorRef: RefObject<HTMLDivElement>;
  src: string;
};

export const VideoScrubbableThumbnail = memo(
  ({ backgroundImageRef, indicatorRef, src, style }: VideoScrubbableThumbnailProps) => (
    // The radius reads the --gallery-card-inner-radius var (set by the public collection page's
    // Corner rounding setting — see shareLinkThumbnailRadius.ts) and falls back to the native 4px,
    // so every surface that doesn't set the var renders exactly as before.
    <div className="pointer-events-none absolute inset-0 size-full overflow-hidden rounded-[var(--gallery-card-inner-radius,4px)]">
      <div
        className="size-full bg-cover"
        style={{
          backgroundImage: `url("${src}")`,
          ...style,
        }}
        ref={backgroundImageRef}
      />
      <div
        className="pointer-events-none absolute top-0 left-0 hidden h-full ads:bg-primary bg-blue-9"
        ref={indicatorRef}
        style={{ width: SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH }}
      />
    </div>
  ),
);

VideoScrubbableThumbnail.displayName = 'VideoScrubbableThumbnail';
